const customerCoordinateLookup = {
  "velammal hospitals": [13.0827, 80.2707],
  "velammal hospitals chennai": [13.0827, 80.2707],
  "velammal hospitals chennai tamil nadu": [13.0827, 80.2707],
  "accura speciality lab": [13.095, 80.282],
  "accura speciality lab chennai": [13.095, 80.282],
  "accura speciality lab chennai tamil nadu": [13.095, 80.282],
  "vanavil scans": [13.067, 80.261],
  "vanavil scans chennai": [13.067, 80.261],
  "vanavil scans chennai tamil nadu": [13.067, 80.261],
  "apollo hospitals": [13.073, 80.22],
  "apollo hospitals chennai": [13.073, 80.22],
  "apollo hospitals chennai tamil nadu": [13.073, 80.22],
  "es hospital": [11.9401, 79.4861],
  "es hospital villupuram": [11.9401, 79.4861],
  "es hospital villupuram tamil nadu": [11.9401, 79.4861],
  "subha anandham hospital": [11.748, 79.7714],
  "subha anandham hospital cuddalore": [11.748, 79.7714],
  "subha anandham hospital cuddalore tamil nadu": [11.748, 79.7714],
  "mahatma gandhi medical college": [11.9416, 79.8083],
  "mahatma gandhi medical college pondicherry": [11.9416, 79.8083],
  "mahatma gandhi medical college pondicherry tamil nadu": [11.9416, 79.8083],
  "g kuppuswamy naidu memorial hospital": [11.005, 76.965],
  "g kuppuswamy naidu memorial hospital coimbatore": [11.005, 76.965],
  "g kuppuswamy naidu memorial hospital coimbatore tamil nadu": [11.005, 76.965],
  "kg hospital": [11.03, 76.97],
  "kg hospital coimbatore": [11.03, 76.97],
  "kg hospital coimbatore tamil nadu": [11.03, 76.97],
  "gknm hospital": [11.0168, 76.9558],
  "gknm hospital coimbatore": [11.0168, 76.9558],
  "gknm hospital coimbatore tamil nadu": [11.0168, 76.9558],
  "psg hospital": [11.02, 76.94],
  "psg hospital coimbatore": [11.02, 76.94],
  "psg hospital coimbatore tamil nadu": [11.02, 76.94],
  "erode cancer centre": [11.341, 77.7172],
  "erode cancer centre erode": [11.341, 77.7172],
  "erode cancer centre erode tamil nadu": [11.341, 77.7172],
  "soorya multispeciality hospital": [11.461, 77.8964],
  "soorya multispeciality hospital thiruchengode": [11.461, 77.8964],
  "soorya multispeciality hospital thiruchengode tamil nadu": [11.461, 77.8964],
  "meenakshi mission hospital and research centre": [9.9252, 78.1198],
  "meenakshi mission hospital and research centre madurai": [9.9252, 78.1198],
  "meenakshi mission hospital and research centre madurai tamil nadu": [9.9252, 78.1198],
  "ksdc hospital": [10.787, 79.1378],
  "ksdc hospital tanjore": [10.787, 79.1378],
  "ksdc hospital tanjore tamil nadu": [10.787, 79.1378],
  "jeeva centenary trust": [10.8, 79.15],
  "jeeva centenary trust tanjore": [10.8, 79.15],
  "jeeva centenary trust tanjore tamil nadu": [10.8, 79.15],
  "annal gandhi memorial hospital": [10.7905, 78.7047],
  "annal gandhi memorial hospital trichy": [10.7905, 78.7047],
  "annal gandhi memorial hospital trichy tamil nadu": [10.7905, 78.7047],
};

export default customerCoordinateLookup;